/* ============================================
   ArquiConstruye — GSAP Premium 2026
   Immersive scroll experience
   ============================================ */

(function () {
  'use strict';

  function onReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  /* ========== LOADER (runs immediately — no DOM dependency) ========== */

  (function loaderInit() {
    var loader = document.getElementById('arqLoader');
    if (!loader) {
      // DOM not ready yet — wait
      onReady(function () {
        var l = document.getElementById('arqLoader');
        if (l) runLoader(l);
      });
      return;
    }
    runLoader(loader);

    function runLoader(el) {
      // Force display on ALL children — theme CSS hides unknown elements
      el.style.setProperty('display', 'block', 'important');
      var allChildren = el.querySelectorAll('*');
      allChildren.forEach(function(child) {
        child.style.setProperty('display', 'block', 'important');
      });

      var fill = el.querySelector('.arq-loader__fill');
      if (fill) fill.style.cssText = 'display:block!important;width:0%;height:100%;background:#A9A9A4;transition:width 0.3s ease;';
      var progress = 0;

      var interval = setInterval(function () {
        progress += Math.random() * 12 + 4;
        if (progress > 95) progress = 95;
        if (fill) fill.style.width = progress + '%';
      }, 160);

      function dismiss() {
        clearInterval(interval);
        if (fill) fill.style.width = '100%';

        setTimeout(function () {
          el.classList.add('done');
          setTimeout(function () {
            el.style.display = 'none';
          }, 1400);
        }, 400);
      }

      if (document.readyState === 'complete') {
        setTimeout(dismiss, 1200);
      } else {
        window.addEventListener('load', function () { setTimeout(dismiss, 1000); });
        setTimeout(dismiss, 3000);
      }
    }
  })();

  /* ========== EVERYTHING ELSE WAITS FOR DOM ========== */

  onReady(function () {
    // Header + cursor work on any page with arq-header
    headerInit();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reducedMotion && document.getElementById('arqCursor')) {
      cursorInit();
    }

    var root = document.querySelector('.arq') || document.querySelector('.arq-coll');
    if (!root) return;
    var isHome = root.classList.contains('arq');

    if (!reducedMotion) {
      if (isHome) sliderInit(root);
    }

    // GSAP — full init only on home, basic reveals on collection
    if (!reducedMotion && isHome) {
      waitForGSAP(function () {
        gsap.registerPlugin(ScrollTrigger);
        gsapInit(root);
        window.addEventListener('load', function () { ScrollTrigger.refresh(); });
      }, 0);
    }
  });

  /* ========== CUSTOM CURSOR ========== */

  function cursorInit() {
    var dot = document.getElementById('arqCursor');
    var ring = document.getElementById('arqCursorRing');
    if (!dot || !ring) return;

    // Force styles inline — no CSS dependency
    dot.style.cssText = 'display:block!important;position:fixed;top:0;left:0;width:10px;height:10px;background:#fff;border-radius:50%;pointer-events:none;z-index:9998;transform:translate(-50%,-50%);opacity:0;transition:width 0.3s ease,height 0.3s ease,background 0.3s ease;';
    ring.style.cssText = 'display:block!important;position:fixed;top:0;left:0;width:40px;height:40px;border:1px solid rgba(255,255,255,0.25);border-radius:50%;pointer-events:none;z-index:9997;transform:translate(-50%,-50%);opacity:0;transition:width 0.3s ease,height 0.3s ease,border-color 0.3s ease;';

    var mx = -100, my = -100;
    var dx = -100, dy = -100;
    var visible = false;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top = my + 'px';
      if (!visible) {
        dot.style.opacity = '1';
        ring.style.opacity = '1';
        visible = true;
      }
    });

    function moveRing() {
      dx += (mx - dx) * 0.12;
      dy += (my - dy) * 0.12;
      ring.style.left = dx + 'px';
      ring.style.top = dy + 'px';
      requestAnimationFrame(moveRing);
    }
    moveRing();

    // Hover on interactive elements
    document.querySelectorAll('a, button, .arq-proto__tab, .arq-process__card, .arq-review, .arq-header a, .arq-burger, .card-wrapper, .collapsible-row summary, .field__input, textarea').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        dot.style.width = '50px';
        dot.style.height = '50px';
        dot.style.background = 'rgba(169,169,164,0.4)';
        ring.style.width = '60px';
        ring.style.height = '60px';
        ring.style.borderColor = '#A9A9A4';
      });
      el.addEventListener('mouseleave', function () {
        dot.style.width = '10px';
        dot.style.height = '10px';
        dot.style.background = '#fff';
        ring.style.width = '40px';
        ring.style.height = '40px';
        ring.style.borderColor = 'rgba(255,255,255,0.25)';
      });
    });
  }

  /* ========== HEADER SCROLL + HAMBURGER ========== */

  function headerInit() {
    var header = document.querySelector('.arq-header');
    var burger = document.querySelector('.arq-burger');
    var nav = document.querySelector('.arq-nav');
    var overlay = document.querySelector('.arq-nav__overlay');
    if (!header || !burger) return;

    // Scroll — add background
    window.addEventListener('scroll', function () {
      if (window.scrollY > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });

    // Hamburger toggle
    burger.addEventListener('click', function () {
      var isOpen = nav.classList.contains('open');
      burger.classList.toggle('active');
      nav.classList.toggle('open');
      overlay.classList.toggle('open');
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    // Close on overlay click
    if (overlay) {
      overlay.addEventListener('click', function () {
        burger.classList.remove('active');
        nav.classList.remove('open');
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      });
    }

    // Close on nav link click
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.classList.remove('active');
        nav.classList.remove('open');
        overlay.classList.remove('open');
        document.body.style.overflow = '';
      });
    });

    // Dropdown toggle for parent items with children
    nav.querySelectorAll('.arq-nav__parent').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('.arq-nav__has-children');
        var isOpen = li.classList.contains('open');
        // Close all other dropdowns
        nav.querySelectorAll('.arq-nav__has-children.open').forEach(function (el) {
          if (el !== li) el.classList.remove('open');
        });
        li.classList.toggle('open');
        btn.setAttribute('aria-expanded', !isOpen);
      });
    });
  }


  /* ========== HERO SLIDER ========== */

  function sliderInit(root) {
    var slides = root.querySelectorAll('.arq-hero__slide');
    var textSlides = root.querySelectorAll('.arq-hero__text-slide');
    var dotsContainer = root.querySelector('.arq-hero__dots');
    var numEl = root.querySelector('.arq-hero__num');

    if (slides.length < 2) {
      var counter = root.querySelector('.arq-hero__counter');
      if (counter) counter.style.display = 'none';
      return;
    }

    var current = 0;
    var total = slides.length;
    var interval;

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'arq-hero__dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', function () { goTo(i); });
      dotsContainer.appendChild(dot);
    });

    function updateNum() {
      if (numEl) numEl.textContent = '0' + (current + 1) + ' / 0' + total;
    }
    updateNum();

    function goTo(idx) {
      // Image
      slides[current].classList.remove('active');
      slides[idx].classList.add('active');
      // Text
      if (textSlides.length) {
        textSlides[current].classList.remove('active');
        textSlides[idx].classList.add('active');
        // Force all children visible — GSAP may have set opacity:0
        textSlides[idx].querySelectorAll('*').forEach(function (el) {
          el.style.opacity = '1';
          el.style.transform = 'none';
        });
      }
      // Dots
      dotsContainer.children[current].classList.remove('active');
      dotsContainer.children[idx].classList.add('active');
      current = idx;
      updateNum();
      resetInterval();
    }

    function next() {
      goTo((current + 1) % total);
    }

    function resetInterval() {
      clearInterval(interval);
      interval = setInterval(next, 5000);
    }

    resetInterval();
  }


  /* ========== WAIT FOR GSAP ========== */

  function waitForGSAP(cb, n) {
    n = n || 0;
    if (window.gsap && window.ScrollTrigger) { cb(); }
    else if (n < 150) { setTimeout(function () { waitForGSAP(cb, n + 1); }, 50); }
  }

  function gsapInit(root) {
    progressBar();
    hero(root);
    intro(root);
    about(root);
    process(root);
    prototipos(root);
    video(root);
    reviews(root);
    finalCta(root);
    footer(root);
    parallax(root);
    geoShapes(root);
  }


  /* ========== SAFE REVEAL HELPER ========== */
  /* gsap.from can leave elements invisible if trigger already passed.
     This helper checks and forces visible state after a timeout. */

  function safeFrom(els, fromVars, triggerEl, startPos) {
    startPos = startPos || 'top 78%';
    gsap.from(els, Object.assign({}, fromVars, {
      scrollTrigger: {
        trigger: triggerEl,
        start: startPos,
        toggleActions: 'play none none none',
        onEnter: function() {},
      }
    }));
    // Safety: if elements are still invisible after 3s, force them visible
    setTimeout(function() {
      if (els.length !== undefined) {
        // NodeList
        Array.prototype.forEach.call(els, function(el) {
          if (getComputedStyle(el).opacity < 0.5) {
            gsap.set(el, { opacity: 1, y: 0, x: 0, scale: 1, clearProps: 'all' });
          }
        });
      } else {
        // Single element
        if (getComputedStyle(els).opacity < 0.5) {
          gsap.set(els, { opacity: 1, y: 0, x: 0, scale: 1, clearProps: 'all' });
        }
      }
    }, 3500);
  }

  /* ========== PROGRESS BAR ========== */

  function progressBar() {
    var bar = document.createElement('div');
    bar.style.cssText = 'display:block!important;position:fixed;top:0;left:0;height:2px;background:rgba(255,255,255,0.35);z-index:10000;pointer-events:none;width:0%;';
    var arqEl = document.querySelector('.arq');
    if (arqEl) { arqEl.appendChild(bar); } else { document.body.appendChild(bar); }
    gsap.fromTo(bar,
      { width: '0%' },
      { width: '100%', ease: 'none',
        scrollTrigger: { trigger: document.documentElement, start: 'top top', end: 'bottom bottom', scrub: 0.3 }
      }
    );
  }


  /* ========== TEXT SPLITTER ========== */

  function splitWords(el) {
    if (!el || !el.textContent.trim()) return [];
    var text = el.textContent;
    var words = text.split(/\s+/).filter(function (w) { return w.length; });
    el.innerHTML = '';
    var inners = [];
    words.forEach(function (word, i) {
      var outer = document.createElement('span');
      outer.className = 'w';
      var inner = document.createElement('span');
      inner.className = 'w-i';
      inner.textContent = word;
      outer.appendChild(inner);
      el.appendChild(outer);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      inners.push(inner);
    });
    return inners;
  }


  /* ========== HERO ========== */

  function hero(root) {
    var sec = root.querySelector('.arq-hero');
    if (!sec) return;

    var activeSlide = sec.querySelector('.arq-hero__slide.active img');
    var activeText = sec.querySelector('.arq-hero__text-slide.active');
    var kicker = activeText ? activeText.querySelector('.arq-hero__kicker') : null;
    var h = activeText ? activeText.querySelector('.arq-hero__h') : null;
    var p = activeText ? activeText.querySelector('.arq-hero__p') : null;
    var btn = activeText ? activeText.querySelector('.arq-hero__btn') : null;
    var scroll = sec.querySelector('.arq-hero__scroll');
    var counter = sec.querySelector('.arq-hero__counter');

    var words = h ? splitWords(h) : [];

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' }, delay: 0.3 });

    if (activeSlide) {
      gsap.set(activeSlide, { scale: 1.18, opacity: 0.5 });
      tl.to(activeSlide, { scale: 1.02, opacity: 1, duration: 2.8, ease: 'power2.out' }, 0);
    }

    if (kicker) tl.to(kicker, { opacity: 1, duration: 0.8 }, 0.4);

    if (words.length) {
      gsap.set(words, { y: '130%' });
      tl.to(words, { y: '0%', duration: 1.4, stagger: 0.06, ease: 'power4.out' }, 0.5);
    }

    if (p) tl.to(p, { opacity: 1, duration: 1.2 }, 1.1);
    if (btn) tl.to(btn, { opacity: 1, y: 0, duration: 1.0 }, 1.3);
    if (scroll) tl.to(scroll, { opacity: 1, duration: 0.8 }, 1.8);
    if (counter) tl.from(counter, { opacity: 0, y: 10, duration: 0.6 }, 1.9);

    // Parallax on all slide images
    sec.querySelectorAll('.arq-hero__slide img').forEach(function (img) {
      gsap.to(img, {
        y: '-20%', ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom top', scrub: true }
      });
    });

    // Fade out text + controls on scroll — use fromTo so scrub reverses correctly
    var texts = sec.querySelector('.arq-hero__texts');
    if (texts) {
      gsap.fromTo(texts,
        { opacity: 1, y: 0 },
        { opacity: 0, y: -80, ease: 'none',
          scrollTrigger: { trigger: sec, start: '35% top', end: '75% top', scrub: true }
        }
      );
    }

    if (scroll) {
      gsap.fromTo(scroll,
        { opacity: 1 },
        { opacity: 0, ease: 'none',
          scrollTrigger: { trigger: sec, start: '8% top', end: '25% top', scrub: true }
        }
      );
    }
    if (counter) {
      gsap.fromTo(counter,
        { opacity: 1 },
        { opacity: 0, ease: 'none',
          scrollTrigger: { trigger: sec, start: '8% top', end: '25% top', scrub: true }
        }
      );
    }
  }


  /* ========== INTRO ========== */

  function intro(root) {
    var sec = root.querySelector('[data-arq="intro"]');
    if (!sec) return;
    var tag = sec.querySelector('.arq-tag');
    var h = sec.querySelector('.arq-intro__h');

    if (tag) {
      gsap.from(tag, { opacity: 0, y: 30, duration: 1.0, ease: 'power3.out',
        scrollTrigger: { trigger: sec, start: 'top 78%', toggleActions: 'play none none none' }
      });
    }
    if (h) {
      var words = splitWords(h);
      if (words.length) {
        gsap.set(words, { y: '100%', opacity: 0 });
        gsap.to(words, { y: '0%', opacity: 1, duration: 1.2, stagger: 0.04, ease: 'power4.out',
          scrollTrigger: { trigger: sec, start: 'top 72%', toggleActions: 'play none none none' }
        });
      }
    }
  }


  /* ========== ABOUT ========== */

  function about(root) {
    var sec = root.querySelector('[data-arq="about"]');
    if (!sec) return;
    var imgWrap = sec.querySelector('.arq-about__img');
    var img = sec.querySelector('.arq-about__img img');
    var tag = sec.querySelector('.arq-tag');
    var h = sec.querySelector('.arq-about__h');
    var line = sec.querySelector('.arq-line');
    var txt = sec.querySelector('.arq-about__txt');
    var feats = sec.querySelectorAll('.arq-about__feat');

    if (imgWrap) {
      gsap.from(imgWrap, { x: -100, opacity: 0, duration: 1.6, ease: 'power3.out',
        scrollTrigger: { trigger: sec, start: 'top 68%', toggleActions: 'play none none none' }
      });
    }
    if (img) {
      gsap.to(img, { y: '-12%', ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }
    var els = [tag, h, line, txt].filter(Boolean);
    if (els.length) {
      gsap.from(els, { y: 50, opacity: 0, duration: 1.2, stagger: 0.15, ease: 'power3.out',
        scrollTrigger: { trigger: sec, start: 'top 65%', toggleActions: 'play none none none' }
      });
    }
    if (feats.length) {
      gsap.from(feats, { y: 30, opacity: 0, duration: 0.9, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: { trigger: feats[0], start: 'top 82%', toggleActions: 'play none none none' }
      });
    }
  }


  /* ========== PROCESS ========== */

  function process(root) {
    var sec = root.querySelector('[data-arq="process"]');
    if (!sec) return;
    var tag = sec.querySelector('.arq-tag');
    var h = sec.querySelector('.arq-process__h');
    var cards = sec.querySelectorAll('.arq-process__card');
    var cta = sec.querySelector('.arq-process__cta a');

    if (tag) gsap.from(tag, { opacity: 0, y: 20, duration: 0.8, ease: 'power3.out',
      scrollTrigger: { trigger: sec, start: 'top 75%', toggleActions: 'play none none none' }
    });
    if (h) gsap.from(h, { opacity: 0, y: 60, duration: 1.3, ease: 'power3.out',
      scrollTrigger: { trigger: sec, start: 'top 72%', toggleActions: 'play none none none' }
    });
    var isMob = window.innerWidth < 768;
    if (cards.length) gsap.from(cards, { y: isMob ? 30 : 40, opacity: 0, duration: 1.0, stagger: 0.08, ease: 'power3.out',
      scrollTrigger: { trigger: cards[0], start: 'top 85%', toggleActions: 'play none none none' }
    });
    if (cta) safeFrom(cta, { y: 20, opacity: 0, duration: 1.0, ease: 'power3.out' }, cta, 'top 90%');
  }


  /* ========== PROTOTIPOS — TABS INTERACTIVOS ========== */

  function prototipos(root) {
    var sec = root.querySelector('[data-arq="prototipos"]');
    if (!sec) return;

    var tag = sec.querySelector('.arq-tag');
    var h = sec.querySelector('.arq-proto__h');
    var imgWrap = sec.querySelector('.arq-proto__img');
    var img = sec.querySelector('.arq-proto__img img');
    var tabs = sec.querySelectorAll('.arq-proto__tab');

    // GSAP reveals
    if (tag) safeFrom(tag, { opacity: 0, y: 20, duration: 0.8, ease: 'power3.out' }, sec, 'top 80%');
    if (h) safeFrom(h, { opacity: 0, y: 50, duration: 1.2, ease: 'power3.out' }, sec, 'top 75%');

    // Image slides in from left
    if (imgWrap) {
      gsap.from(imgWrap, {
        x: -100, opacity: 0, duration: 1.6, ease: 'power3.out',
        scrollTrigger: { trigger: sec, start: 'top 68%', toggleActions: 'play none none none' }
      });
    }

    // Tabs stagger in
    if (tabs.length) {
      safeFrom(tabs, { y: 30, opacity: 0, duration: 0.9, stagger: 0.1, ease: 'power3.out' }, sec, 'top 70%');
    }

    // Tab interaction + auto-play
    if (tabs.length < 2) return;
    var current = 0;
    var interval;

    // Lock SECTION height to prevent page jump on tab change
    var tabsContainer = sec.querySelector('.arq-proto__tabs');
    if (tabsContainer) {
      // Temporarily open all tabs to measure max section height
      tabs.forEach(function(t) { t.classList.add('active'); });
      void sec.offsetHeight; // force reflow
      var maxTabsH = tabsContainer.scrollHeight;
      var maxSecH = sec.scrollHeight;
      tabs.forEach(function(t) { t.classList.remove('active'); });
      tabs[0].classList.add('active');
      tabsContainer.style.setProperty('--arq-proto-tabs-h', maxTabsH + 'px');
      sec.style.setProperty('--arq-proto-section-h', maxSecH + 'px');
    }

    // --- goTo: cambia de tab, opcionalmente con smooth fill ---
    function goTo(idx, smooth) {
      tabs.forEach(function(t) {
        t.classList.remove('active', 'smooth-fill');
      });
      void tabs[idx].offsetWidth; // reflow for animation restart
      tabs[idx].classList.add('active');
      if (smooth) tabs[idx].classList.add('smooth-fill');
      current = idx;
    }

    function next() {
      goTo((current + 1) % tabs.length, false);
    }

    function resetInterval() {
      clearInterval(interval);
      interval = setInterval(next, 5000);
    }

    function startAutoplay() {
      // Reinicia autoplay: quita smooth-fill del actual, reinicia animación
      tabs[current].classList.remove('smooth-fill');
      void tabs[current].offsetWidth;
      tabs[current].classList.add('active');
      resetInterval();
    }

    // --- Hover en un tab ---
    tabs.forEach(function (tab, i) {
      tab.addEventListener('mouseenter', function () {
        // Hover → no hace nada, el tab actual sigue su flujo normal
      });

      tab.addEventListener('mouseleave', function () {
        // No hace nada al salir del tab individual
      });

      // --- Click en un tab ---
      tab.addEventListener('click', function () {
        if (i === current) {
          // Click en el tab activo → completa smooth
          tab.classList.add('smooth-fill');
        } else {
          // Click en otro tab → cambia con smooth fill, pausa autoplay
          clearInterval(interval);
          goTo(i, true);
        }
      });
    });

    // --- Mouse sale de la sección → reinicia autoplay ---
    sec.addEventListener('mouseleave', function () {
      startAutoplay();
    });

    resetInterval();
  }


  /* ========== VIDEO ========== */

  function video(root) {
    var sec = root.querySelector('[data-arq="video"]');
    if (!sec) return;
    var box = sec.querySelector('.arq-vid__box');
    var h = sec.querySelector('.arq-vid__h');
    var btn = sec.querySelector('.arq-vid__btn');

    if (box) gsap.fromTo(box,
      { scale: 0.82, borderRadius: '24px', opacity: 0.6 },
      { scale: 1, borderRadius: '0px', opacity: 1, ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top 82%', end: 'top 20%', scrub: true }
      }
    );
    if (h) safeFrom(h, { y: 50, opacity: 0, duration: 1.2, ease: 'power3.out' }, h, 'top 85%');
    if (btn) safeFrom(btn, { y: 20, opacity: 0, duration: 0.9, ease: 'power3.out' }, btn, 'top 90%');
  }


  /* ========== REVIEWS ========== */

  function reviews(root) {
    var sec = root.querySelector('[data-arq="testimonials"]');
    if (!sec) return;
    var tag = sec.querySelector('.arq-tag');
    var h = sec.querySelector('.arq-reviews__h');
    var cards = sec.querySelectorAll('.arq-review');

    if (tag) safeFrom(tag, { opacity: 0, y: 20, duration: 0.8, ease: 'power3.out' }, sec, 'top 80%');
    if (h) safeFrom(h, { opacity: 0, y: 60, duration: 1.3, ease: 'power3.out' }, sec, 'top 75%');
    if (cards.length) safeFrom(cards, { y: 100, opacity: 0, duration: 1.2, stagger: 0.18, ease: 'power3.out' }, sec, 'top 78%');
  }


  /* ========== FINAL ========== */

  function finalCta(root) {
    var sec = root.querySelector('[data-arq="final"]');
    if (!sec) return;
    var els = sec.querySelectorAll('.arq-tag, .arq-final__h, .arq-final__sub, .arq-final__btn');
    if (els.length) safeFrom(els, { y: 60, opacity: 0, duration: 1.3, stagger: 0.15, ease: 'power3.out' }, sec, 'top 78%');
  }


  /* ========== FOOTER ========== */

  function footer(root) {
    var ft = root.querySelector('.arq-footer');
    if (!ft) return;
    var cols = ft.querySelectorAll('.arq-footer__brand, .arq-footer__col');
    if (cols.length) safeFrom(cols, { y: 40, opacity: 0, duration: 1.0, stagger: 0.1, ease: 'power3.out' }, ft, 'top 85%');
  }


  /* ========== PARALLAX ========== */

  function parallax(root) {
    root.querySelectorAll('.arq-process__card-img').forEach(function (img) {
      var parent = img.parentElement;
      if (!parent) return;
      gsap.to(img, { y: '-15%', ease: 'none',
        scrollTrigger: { trigger: parent, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }


  /* ========== GEOMETRIC SHAPES — SCROLL ANIMATED ========== */

  function geoShapes(root) {
    var geos = root.querySelectorAll('.arq-geo');
    if (!geos.length) return;

    geos.forEach(function (geo) {
      var section = geo.closest('section');
      if (!section) return;

      // Each geo rotates and translates on scroll
      var direction = geo.classList.contains('arq-geo--tl') || geo.classList.contains('arq-geo--bl') ? 1 : -1;

      gsap.to(geo, {
        rotation: direction * 90,
        y: direction * -40,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });

      // Fade in when section enters
      gsap.from(geo, {
        opacity: 0,
        scale: 0.7,
        duration: 1.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      });
    });
  }

})();
